import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { ToastService } from '../../../main/services';
import {Contract, Round, Tender} from '../../models';
import {User} from '../../../auth/models';

@Component({
    selector: 'jft-tender-index-analysis',
    templateUrl: './tender-contract-dashboard-index-analysis.component.html',
    styleUrls: ['./tender-contract-dashboard-index-analysis.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderContractDashboardIndexAnalysisComponent implements OnInit {
    public tender: Tender;
    public contract: Contract;
    public rounds: Round[] = [];
    public roundNum: number;
    public round: Round;

    constructor(
        public user: User,
        private route: ActivatedRoute,
        protected toast: ToastService,
        private router: Router,
    ) {
    }

    ngOnInit() {
        let data = this.route.parent.snapshot.data,
            parentParentData = this.route.parent.parent.parent.snapshot.data,
            parentData = this.route.parent.snapshot.data;
        this.contract = data['contract'];
        this.tender = parentParentData['tender'];
        this.rounds = parentData['rounds'] || [];
        this.roundNum = this.route.snapshot.params.rid;
        this.round = this.rounds.filter(item => item.round == this.roundNum)[0];
    }

    public roundChanged(round) {
        this.round = round;
        this.router.navigate(['index-analysis', 'round', this.round.round, 'graph'], { relativeTo: this.route.parent });
    }
}
